(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hr-cable-science"] && !Shopify.designMode) return;
  try {
    
/* hr-cable-science */
(function () {
  if (window.__hrCableSciInit) return;
  window.__hrCableSciInit = true;

  function init() {
    var SCIENCE = [
      { label: "Step 01 · Connect", title: "Connect", body: "Plug the cable into the charging port at the base of your HealRay device. The connection is magnetic — it clicks into place easily." },
      { label: "Step 02 · Charge", title: "Charge", body: "Rest your device on the magnetic base and let it charge fully. A single full charge powers multiple sessions, so it is always ready when you are." },
      { label: "Step 03 · Store Safely", title: "Store Safely", body: "When you are done, coil the cable loosely and keep it with your device somewhere dry — no tight bends or strain on the connector." },
    ];

    var SCIENCE_REFERENCES = [
      {
        title: "01 — Inflammation",
        subtitle: "How Red & Infrared Light Supports Inflammatory Balance",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Photobiomodulation (PBM) has been shown to influence key inflammatory signaling pathways in oral tissues. Red and near-infrared wavelengths interact with cells to help regulate pro-inflammatory cytokines and oxidative stress markers — both of which play a role in gum tissue breakdown.<br><br>In periodontal research, adjunctive light therapy has been associated with reduced bleeding, improved clinical attachment levels, and healthier tissue response when combined with standard care.<br><br><strong>Clinical References</strong><br><br><strong>Lee et al., 2017 – Lasers in Medical Science</strong><br>Low-level laser therapy demonstrated anti-inflammatory effects in periodontal ligament cells and reduced inflammatory mediator expression.<br><br><strong>Qadri et al., 2005 – Journal of Clinical Periodontology</strong><br>Adjunct low-level laser therapy reduced gingival inflammation and bleeding.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review describing PBM's ability to downregulate NF-κB and inflammatory cytokines.",
        figure: null
      },
      {
        title: "02 — Collagen Health",
        subtitle: "Supporting Structural Integrity of Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Collagen is the primary structural protein that anchors teeth within gum tissue. Red and near-infrared light therapy has been shown to stimulate fibroblast activity — the cells responsible for collagen production and extracellular matrix maintenance.<br><br>Laboratory and clinical studies report increased collagen synthesis and improved soft tissue repair responses following photobiomodulation.<br><br><strong>Clinical References</strong><br><br><strong>Kreisler et al., 2003 – Journal of Clinical Periodontology</strong><br>Increased gingival fibroblast proliferation after laser exposure.<br><br><strong>Pourzarandian et al., 2005 – Journal of Periodontal Research</strong><br>Enhanced collagen synthesis in gingival fibroblasts following PBM.<br><br><strong>Pinheiro &amp; Gerbi, 2006 – Photomedicine and Laser Surgery</strong><br>Review of PBM's role in connective tissue regeneration.",
        figure: null
      },
      {
        title: "03 — Blood Flow",
        subtitle: "Enhancing Microcirculation in Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared light therapy has been shown to increase local microcirculation and promote nitric oxide release, which plays a role in vascular dilation.<br><br>Improved blood flow supports oxygen delivery and nutrient transport — both essential for tissue maintenance and recovery. In periodontal contexts, PBM has been associated with improved wound healing responses and angiogenesis.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Mechanisms linking PBM to nitric oxide release and circulation effects.<br><br><strong>Romanenko et al., 2025 – Lasers in Medical Science</strong><br>Laser Doppler measurements showed increased gingival microcirculation following photobiomodulation.",
        figure: null
      },
      {
        title: "04 — Cellular Energy",
        subtitle: "Supporting Mitochondrial Function for Tissue Repair",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared photons are absorbed by mitochondrial cytochrome c oxidase, supporting cellular ATP production. Improved cellular energy underpins virtually every reparative process, including gum tissue maintenance.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Cytochrome c oxidase as the primary photoacceptor in cells.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review of PBM mechanisms via mitochondrial signaling.",
        figure: null
      }
    ];

    var scienceTabButtons = Array.prototype.slice.call(document.querySelectorAll(".cable-science-tab-item"));
    var scienceLabel = document.getElementById("cable-science-label");
    var scienceTitle = document.getElementById("cable-science-title");
    var scienceBody = document.getElementById("cable-science-body");
    var activeScienceIndex = 0;

    // Mobile: the single panel moves directly under the active tab (accordion).
    // Desktop (>=768): it returns to its grid position (right column).
    var sciencePanel = document.querySelector(".cable-science-panel");
    var sciencePanelHome = sciencePanel ? sciencePanel.parentNode : null;
    var scienceMobileMql = window.matchMedia("(max-width: 767.98px)");

    function placeSciencePanel(index) {
      if (!sciencePanel || !sciencePanelHome) return;
      if (scienceMobileMql.matches) {
        var btn = scienceTabButtons[index];
        if (btn && btn.nextElementSibling !== sciencePanel) {
          btn.insertAdjacentElement("afterend", sciencePanel);
        }
      } else if (sciencePanel.parentNode !== sciencePanelHome) {
        sciencePanelHome.appendChild(sciencePanel); // restore: last child of .cable-science-grid
      }
    }

    function setScienceState(index) {
      var safe = Math.max(0, Math.min(SCIENCE.length - 1, index));
      var item = SCIENCE[safe] || SCIENCE[0];
      activeScienceIndex = safe;
      if (scienceLabel) scienceLabel.textContent = item.label;
      if (scienceTitle) scienceTitle.textContent = item.title;
      if (scienceBody) scienceBody.textContent = item.body;
      scienceTabButtons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === safe);
      });
      placeSciencePanel(safe);
    }

    if (scienceTabButtons.length) {
      scienceTabButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var idx = Number(button.getAttribute("data-cable-science-tab")) || 0;
          setScienceState(idx);
        });
      });
      setScienceState(0);
      // Re-place the panel when crossing the mobile/desktop breakpoint.
      var onScienceMqlChange = function () { placeSciencePanel(activeScienceIndex); };
      if (scienceMobileMql.addEventListener) {
        scienceMobileMql.addEventListener("change", onScienceMqlChange);
      } else if (scienceMobileMql.addListener) {
        scienceMobileMql.addListener(onScienceMqlChange);
      }
    }

    var dialog = document.getElementById("cable-science-reference-dialog");
    var panel = dialog ? dialog.querySelector(".cable-science-reference-dialog__panel") : null;
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-cable-science-reference-open]"));
    var closers = dialog ? Array.prototype.slice.call(dialog.querySelectorAll("[data-cable-science-reference-close]")) : [];
    var refTitle = document.getElementById("cable-science-reference-title");
    var refSubtitle = document.getElementById("cable-science-reference-subtitle");
    var refSectionTitle = document.getElementById("cable-science-reference-section-title");
    var refSubsectionTitle = document.getElementById("cable-science-reference-subsection-title");
    var refBody = document.getElementById("cable-science-reference-body");
    var refFigure = document.getElementById("cable-science-reference-figure");
    var refFigureImg = document.getElementById("cable-science-reference-figure-image");
    var refFigureCap = document.getElementById("cable-science-reference-figure-caption");
    var lastTrigger = null;

    function updateRef(index) {
      var safe = Math.max(0, Math.min(SCIENCE_REFERENCES.length - 1, index));
      var r = SCIENCE_REFERENCES[safe] || SCIENCE_REFERENCES[0];
      if (refTitle) refTitle.textContent = r.title;
      if (refSubtitle) refSubtitle.textContent = r.subtitle;
      if (refSectionTitle) refSectionTitle.textContent = r.sectionTitle;
      if (refSubsectionTitle) refSubsectionTitle.textContent = r.subsectionTitle;
      if (refBody) refBody.innerHTML = r.bodyHtml;
      if (!refFigure || !refFigureImg || !refFigureCap) return;
      if (r.figure && r.figure.src) {
        refFigure.hidden = false;
        refFigureImg.setAttribute("src", r.figure.src);
        refFigureImg.setAttribute("alt", r.figure.alt || "");
        refFigureCap.innerHTML = r.figure.captionHtml || "";
        return;
      }
      refFigure.hidden = true;
      refFigureImg.removeAttribute("src");
      refFigureImg.setAttribute("alt", "");
      refFigureCap.textContent = "";
    }

    function setDialog(open) {
      if (!dialog) return;
      document.body.classList.toggle("cable-science-reference-dialog-open", open);
      dialog.classList.toggle("is-open", open);
      dialog.setAttribute("aria-hidden", String(!open));
      if (open) {
        updateRef(activeScienceIndex);
        window.setTimeout(function () { if (panel) panel.focus(); }, 0);
        return;
      }
      if (lastTrigger) lastTrigger.focus();
    }

    if (dialog && openers.length) {
      openers.forEach(function (t) {
        t.addEventListener("click", function () {
          lastTrigger = t;
          setDialog(true);
        });
      });
      closers.forEach(function (c) {
        c.addEventListener("click", function () { setDialog(false); });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-contact-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(section) {
    var items = Array.prototype.slice.call(section.querySelectorAll('.faq-item'));
    if (!items.length) return;

    function setHeight(item) {
      var ans = item.querySelector('.faq-item__a');
      if (ans) ans.style.setProperty('--accordion-content-height', ans.scrollHeight + 'px');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-item__toggle');
      if (!btn) return;
      if (item.classList.contains('is-open')) setHeight(item);
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        if (open) setHeight(item);
      });
    });

    var raf = 0;
    window.addEventListener('resize', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        items.forEach(function (item) {
          if (item.classList.contains('is-open')) setHeight(item);
        });
        raf = 0;
      });
    });
  }

  function boot() {
    document.querySelectorAll('.hr-faq').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-cw-science"] && !Shopify.designMode) return;
  try {
    
/* hr-nt-cw-science */
(function () {
  if (window.__hrNtSciInit) return;
  window.__hrNtSciInit = true;

  function init() {
    var SCIENCE = [
      { label: "01 · Silicone-Safe Formula", title: "Protects Your Device", body: "Specifically formulated to clean without breaking down the mouthpiece material — so your device stays effective session after session." },
      { label: "02 · Residue", title: "Leaves Nothing Behind", body: "No alcohol, no oil, no dye. Wipes clean without leaving residue or aftertaste — so your next session starts fresh." },
      { label: "03 · Single-Use Sachets", title: "Sealed for Hygiene", body: "Each wipe is individually sealed to maintain freshness and prevent contamination. Tear, wipe, dispose — no cross-use, no guesswork." },
      { label: "04 · No Rinse Needed", title: "Clean in Under 30 Seconds", body: "Wipe and you\'re done. No water, no rinsing, no waiting. Designed for convenience before or after every session." },
    ];

    var SCIENCE_REFERENCES = [
      {
        title: "01 — Inflammation",
        subtitle: "How Red & Infrared Light Supports Inflammatory Balance",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Photobiomodulation (PBM) has been shown to influence key inflammatory signaling pathways in oral tissues. Red and near-infrared wavelengths interact with cells to help regulate pro-inflammatory cytokines and oxidative stress markers — both of which play a role in gum tissue breakdown.<br><br>In periodontal research, adjunctive light therapy has been associated with reduced bleeding, improved clinical attachment levels, and healthier tissue response when combined with standard care.<br><br><strong>Clinical References</strong><br><br><strong>Lee et al., 2017 – Lasers in Medical Science</strong><br>Low-level laser therapy demonstrated anti-inflammatory effects in periodontal ligament cells and reduced inflammatory mediator expression.<br><br><strong>Qadri et al., 2005 – Journal of Clinical Periodontology</strong><br>Adjunct low-level laser therapy reduced gingival inflammation and bleeding.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review describing PBM's ability to downregulate NF-κB and inflammatory cytokines.",
        figure: null
      },
      {
        title: "02 — Collagen Health",
        subtitle: "Supporting Structural Integrity of Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Collagen is the primary structural protein that anchors teeth within gum tissue. Red and near-infrared light therapy has been shown to stimulate fibroblast activity — the cells responsible for collagen production and extracellular matrix maintenance.<br><br>Laboratory and clinical studies report increased collagen synthesis and improved soft tissue repair responses following photobiomodulation.<br><br><strong>Clinical References</strong><br><br><strong>Kreisler et al., 2003 – Journal of Clinical Periodontology</strong><br>Increased gingival fibroblast proliferation after laser exposure.<br><br><strong>Pourzarandian et al., 2005 – Journal of Periodontal Research</strong><br>Enhanced collagen synthesis in gingival fibroblasts following PBM.<br><br><strong>Pinheiro &amp; Gerbi, 2006 – Photomedicine and Laser Surgery</strong><br>Review of PBM's role in connective tissue regeneration.",
        figure: null
      },
      {
        title: "03 — Blood Flow",
        subtitle: "Enhancing Microcirculation in Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared light therapy has been shown to increase local microcirculation and promote nitric oxide release, which plays a role in vascular dilation.<br><br>Improved blood flow supports oxygen delivery and nutrient transport — both essential for tissue maintenance and recovery. In periodontal contexts, PBM has been associated with improved wound healing responses and angiogenesis.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Mechanisms linking PBM to nitric oxide release and circulation effects.<br><br><strong>Romanenko et al., 2025 – Lasers in Medical Science</strong><br>Laser Doppler measurements showed increased gingival microcirculation following photobiomodulation.",
        figure: null
      },
      {
        title: "04 — Cellular Energy",
        subtitle: "Supporting Mitochondrial Function for Tissue Repair",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared photons are absorbed by mitochondrial cytochrome c oxidase, supporting cellular ATP production. Improved cellular energy underpins virtually every reparative process, including gum tissue maintenance.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Cytochrome c oxidase as the primary photoacceptor in cells.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review of PBM mechanisms via mitochondrial signaling.",
        figure: null
      }
    ];

    var scienceTabButtons = Array.prototype.slice.call(document.querySelectorAll(".cw-science-tab-item"));
    var scienceLabel = document.getElementById("cw-science-label");
    var scienceTitle = document.getElementById("cw-science-title");
    var scienceBody = document.getElementById("cw-science-body");
    var activeScienceIndex = 0;

    // Mobile: the single panel moves directly under the active tab (accordion).
    // Desktop (>=768): it returns to its grid position (right column).
    var sciencePanel = document.querySelector(".cw-science-panel");
    var sciencePanelHome = sciencePanel ? sciencePanel.parentNode : null;
    var scienceMobileMql = window.matchMedia("(max-width: 767.98px)");

    function placeSciencePanel(index) {
      if (!sciencePanel || !sciencePanelHome) return;
      if (scienceMobileMql.matches) {
        var btn = scienceTabButtons[index];
        if (btn && btn.nextElementSibling !== sciencePanel) {
          btn.insertAdjacentElement("afterend", sciencePanel);
        }
      } else if (sciencePanel.parentNode !== sciencePanelHome) {
        sciencePanelHome.appendChild(sciencePanel);
      }
    }

    function setScienceState(index) {
      var safe = Math.max(0, Math.min(SCIENCE.length - 1, index));
      var item = SCIENCE[safe] || SCIENCE[0];
      activeScienceIndex = safe;
      if (scienceLabel) scienceLabel.textContent = item.label;
      if (scienceTitle) scienceTitle.textContent = item.title;
      if (scienceBody) scienceBody.textContent = item.body;
      scienceTabButtons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === safe);
      });
      placeSciencePanel(safe);
    }

    if (scienceTabButtons.length) {
      scienceTabButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var idx = Number(button.getAttribute("data-cw-science-tab")) || 0;
          setScienceState(idx);
        });
      });
      setScienceState(0);
      var onScienceMqlChange = function () { placeSciencePanel(activeScienceIndex); };
      if (scienceMobileMql.addEventListener) {
        scienceMobileMql.addEventListener("change", onScienceMqlChange);
      } else if (scienceMobileMql.addListener) {
        scienceMobileMql.addListener(onScienceMqlChange);
      }
    }

    var dialog = document.getElementById("cw-science-reference-dialog");
    var panel = dialog ? dialog.querySelector(".cw-science-reference-dialog__panel") : null;
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-cw-science-reference-open]"));
    var closers = dialog ? Array.prototype.slice.call(dialog.querySelectorAll("[data-cw-science-reference-close]")) : [];
    var refTitle = document.getElementById("cw-science-reference-title");
    var refSubtitle = document.getElementById("cw-science-reference-subtitle");
    var refSectionTitle = document.getElementById("cw-science-reference-section-title");
    var refSubsectionTitle = document.getElementById("cw-science-reference-subsection-title");
    var refBody = document.getElementById("cw-science-reference-body");
    var refFigure = document.getElementById("cw-science-reference-figure");
    var refFigureImg = document.getElementById("cw-science-reference-figure-image");
    var refFigureCap = document.getElementById("cw-science-reference-figure-caption");
    var lastTrigger = null;

    function updateRef(index) {
      var safe = Math.max(0, Math.min(SCIENCE_REFERENCES.length - 1, index));
      var r = SCIENCE_REFERENCES[safe] || SCIENCE_REFERENCES[0];
      if (refTitle) refTitle.textContent = r.title;
      if (refSubtitle) refSubtitle.textContent = r.subtitle;
      if (refSectionTitle) refSectionTitle.textContent = r.sectionTitle;
      if (refSubsectionTitle) refSubsectionTitle.textContent = r.subsectionTitle;
      if (refBody) refBody.innerHTML = r.bodyHtml;
      if (!refFigure || !refFigureImg || !refFigureCap) return;
      if (r.figure && r.figure.src) {
        refFigure.hidden = false;
        refFigureImg.setAttribute("src", r.figure.src);
        refFigureImg.setAttribute("alt", r.figure.alt || "");
        refFigureCap.innerHTML = r.figure.captionHtml || "";
        return;
      }
      refFigure.hidden = true;
      refFigureImg.removeAttribute("src");
      refFigureImg.setAttribute("alt", "");
      refFigureCap.textContent = "";
    }

    function setDialog(open) {
      if (!dialog) return;
      document.body.classList.toggle("cw-science-reference-dialog-open", open);
      dialog.classList.toggle("is-open", open);
      dialog.setAttribute("aria-hidden", String(!open));
      if (open) {
        updateRef(activeScienceIndex);
        window.setTimeout(function () { if (panel) panel.focus(); }, 0);
        return;
      }
      if (lastTrigger) lastTrigger.focus();
    }

    if (dialog && openers.length) {
      openers.forEach(function (t) {
        t.addEventListener("click", function () {
          lastTrigger = t;
          setDialog(true);
        });
      });
      closers.forEach(function (c) {
        c.addEventListener("click", function () { setDialog(false); });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFooterAccordion(footer) {
    var cols = Array.prototype.slice.call(footer.querySelectorAll('.footer__col'));
    if (!cols.length) return;

    function setHeight(col) {
      var panel = col.querySelector('.footer__col-panel');
      if (panel) panel.style.setProperty('--accordion-content-height', panel.scrollHeight + 'px');
    }

    cols.forEach(function (col) {
      var btn = col.querySelector('.footer__col-toggle');
      if (!btn) return;
      if (col.classList.contains('is-open')) setHeight(col);
      btn.addEventListener('click', function () {
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        if (open) setHeight(col);
      });
    });

    var raf = 0;
    window.addEventListener('resize', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        cols.forEach(function (col) {
          if (col.classList.contains('is-open')) setHeight(col);
        });
        raf = 0;
      });
    });
  }

  function boot() {
    document.querySelectorAll('.footer').forEach(initFooterAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-globals"] && !Shopify.designMode) return;
  try {
    
// ===== customers.js =====
// customers.js — drives the "Everyday Customers" video carousel.
// Step = one card width per click; arrows disable at each end; progress bar
// fills based on how much of the track is visible.

(() => {
  const section = document.querySelector('.customers');
  if (!section) return;

  const track = section.querySelector('.customers__track');
  const cards = track && track.querySelectorAll('.customer-card');
  const prev = section.querySelector('.icon-btn--prev');
  const next = section.querySelector('.icon-btn--next');
  const fill = section.querySelector('.customers__progress-fill');
  if (!track || !cards || cards.length === 0 || !prev || !next) return;

  const step = () => {
    if (cards.length < 2) return cards[0].offsetWidth;
    return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
  };

  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    prev.disabled = x <= 1;
    next.disabled = x >= max - 1;
    if (fill) {
      const pct = track.scrollWidth > 0
        ? Math.min(100, ((x + track.clientWidth) / track.scrollWidth) * 100)
        : 100;
      fill.style.width = pct + '%';
    }
  };

  prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();


// ===== experts.js =====
(function () {
    const root = document.querySelector('.hr-experts');
    if (!root) return;

    const avatars = Array.from(root.querySelectorAll('.hr-experts__avatar'));
    const featured = root.querySelector('.hr-experts__featured');
    const featuredImg = featured && featured.querySelector('.hr-experts__featured-img');
    const quote = root.querySelector('.hr-experts__quote');
    const quoteText = quote && quote.querySelector('.hr-experts__quote-text');
    const cite = quote && quote.querySelector('.hr-experts__cite');
    const role = quote && quote.querySelector('.hr-experts__role');

    if (!featuredImg || !quoteText || !cite || !role) return;

    function activate(button) {
        if (button.classList.contains('is-active')) return;

        avatars.forEach((b) => {
            const on = b === button;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        const data = button.dataset;
        if (data.img) {
            featuredImg.src = data.img;
            featuredImg.alt = data.alt || '';
        }
        if (data.name) cite.textContent = data.name;
        if (data.role) role.textContent = data.role;
        if (data.quote) quoteText.textContent = '“' + data.quote + '”';

        [featured, quote].forEach((el) => {
            el.classList.remove('is-popping');
            void el.offsetWidth;
            el.classList.add('is-popping');
        });
    }

    avatars.forEach((btn) => {
        btn.addEventListener('click', () => activate(btn));
    });

    [featured, quote].forEach((el) => {
        el.addEventListener('animationend', () => {
            el.classList.remove('is-popping');
        });
    });
})();


// ===== slider.js =====
// Generic horizontal slider behaviour.
// Markup contract (set via data-* so multiple carousels can opt in):
//   <div data-slider>
//     <ul data-slider-track>           ← the scroll-snap-x scroller
//       <li>…</li>
//     </ul>
//     <button data-slider-prev></button>     (optional)
//     <button data-slider-next></button>     (optional)
//     <div data-slider-progress></div>       (optional — receives --progress)
//   </div>
//
// No deps. No animations beyond native smooth-scroll. CSS still owns layout/snap.

(() => {
  const init = (root) => {
    const track = root.querySelector("[data-slider-track]");
    if (!track) return;
    const prev = root.querySelector("[data-slider-prev]");
    const next = root.querySelector("[data-slider-next]");
    const progress = root.querySelector("[data-slider-progress]");

    const stepSize = () => {
      const card = track.firstElementChild;
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const scrollByStep = (dir) => {
      track.scrollBy({ left: dir * stepSize(), behavior: "smooth" });
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 1;
      if (progress) progress.style.setProperty("--progress", (ratio * 100).toFixed(2) + "%");
      if (prev) prev.toggleAttribute("disabled", track.scrollLeft <= 1);
      if (next) next.toggleAttribute("disabled", track.scrollLeft >= max - 1);
    };

    prev?.addEventListener("click", () => scrollByStep(-1));
    next?.addEventListener("click", () => scrollByStep(1));
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    // run after layout settles (images may shift widths)
    requestAnimationFrame(update);
  };

  const boot = () => document.querySelectorAll("[data-slider]").forEach(init);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Halloween countdown — ticks to the ISO end time from Theme settings.
  const countdown = document.querySelector("[data-hr-countdown]");
  if (countdown) {
    const endsAt = Date.parse(countdown.dataset.hrCountdown);
    const cells = {};
    countdown.querySelectorAll("[data-unit]").forEach((el) => {
      cells[el.dataset.unit] = el;
    });
    const pad = (n) => String(n).padStart(2, "0");
    const tick = () => {
      const left = Number.isNaN(endsAt) ? 0 : Math.max(0, endsAt - Date.now());
      const secs = Math.floor(left / 1000);
      cells.days.textContent = pad(Math.floor(secs / 86400));
      cells.hours.textContent = pad(Math.floor((secs % 86400) / 3600));
      cells.minutes.textContent = pad(Math.floor((secs % 3600) / 60));
      cells.seconds.textContent = pad(secs % 60);
      return left > 0;
    };
    if (tick()) {
      const timer = setInterval(() => {
        if (!tick()) clearInterval(timer);
      }, 1000);
    }
  }

  const root = document.querySelector("[data-hr-header]");
  if (!root) return;

  // Lift the floating nav up once the topbar has scrolled out of view.
  const onScroll = () => {
    root.classList.toggle("is-scrolled", window.scrollY > 40);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const nav = root.querySelector("[data-hr-nav]");
  const menuToggle = root.querySelector("[data-hr-menu-toggle]");
  const dismissers = Array.from(root.querySelectorAll("[data-hr-menu-dismiss]"));
  const triggers = Array.from(root.querySelectorAll("[data-hr-trigger]"));
  const panels = Array.from(root.querySelectorAll("[data-hr-panel]"));
  if (!nav || (!triggers.length && !menuToggle)) return;

  const triggerFor = (key) => triggers.find((t) => t.dataset.hrTrigger === key);
  const isMobile = () => window.matchMedia("(max-width: 1023px)").matches;
  let openKey = null;

  function setPanel(key) {
    panels.forEach((panel) => {
      const isTarget = panel.dataset.hrPanel === key;
      panel.classList.toggle("is-open", isTarget);
      panel.setAttribute("aria-hidden", isTarget ? "false" : "true");
      if (isTarget) {
        panel.removeAttribute("inert");
      } else {
        panel.setAttribute("inert", "");
      }
    });
    triggers.forEach((trigger) => {
      const active = trigger.dataset.hrTrigger === key;
      trigger.setAttribute("aria-expanded", active ? "true" : "false");
      trigger.classList.toggle("is-active", active);
    });
    nav.classList.toggle("is-open", key !== null);
    syncScrollLock();
    openKey = key;
  }

  function syncScrollLock() {
    // Scroll locking intentionally disabled — the page stays scrollable while the menu is open.
  }

  function openMenu() {
    nav.classList.add("is-menu-open");
    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "true");
      menuToggle.setAttribute("aria-label", "Close menu");
    }
    syncScrollLock();
  }

  function closeMenu() {
    nav.classList.remove("is-menu-open");
    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.setAttribute("aria-label", "Open menu");
    }
    syncScrollLock();
  }

  function closeAll() {
    setPanel(null);
    closeMenu();
  }

  if (menuToggle) {
    menuToggle.addEventListener("click", (e) => {
      e.preventDefault();
      if (nav.classList.contains("is-menu-open")) {
        closeAll();
      } else {
        openMenu();
        setPanel("shop"); // default panel when the mobile menu opens
      }
    });
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      // Link triggers (e.g. Shop) navigate to their href instead of toggling.
      if (trigger.tagName === "A") return;
      e.preventDefault();
      const key = trigger.dataset.hrTrigger;
      if (openKey === key) {
        if (isMobile()) closeAll();
        else setPanel(null);
      } else {
        if (isMobile()) openMenu();
        setPanel(key);
      }
    });
  });

  // ── Desktop: open on hover, close when the pointer leaves both the
  //    nav links and the open panel. Disabled on mobile (tap-only). ──
  let hoverTimer = null;
  const clearHoverTimer = () => {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("mouseenter", () => {
      if (isMobile()) return;
      clearHoverTimer();
      setPanel(trigger.dataset.hrTrigger);
    });
  });

  function scheduleHoverClose() {
    if (isMobile()) return;
    clearHoverTimer();
    hoverTimer = setTimeout(() => {
      if (openKey !== null) setPanel(null);
    }, 120);
  }

  nav.addEventListener("mouseleave", scheduleHoverClose);
  nav.addEventListener("mouseenter", clearHoverTimer);

  dismissers.forEach((d) => d.addEventListener("click", () => closeAll()));

  document.addEventListener("click", (e) => {
    if (
      (openKey !== null || nav.classList.contains("is-menu-open")) &&
      !nav.contains(e.target)
    ) {
      closeAll();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const mobileOpen = nav.classList.contains("is-menu-open");
    if (openKey === null && !mobileOpen) return;
    const active = triggerFor(openKey);
    closeAll();
    if (mobileOpen && menuToggle) menuToggle.focus();
    else if (active) active.focus();
  });

  panels.forEach((panel) => {
    panel.addEventListener("click", (e) => {
      if (e.target.closest("a")) closeAll();
    });
  });

  // Reset menu state when the viewport crosses the desktop breakpoint
  let wasMobile = isMobile();
  window.addEventListener("resize", () => {
    const nowMobile = isMobile();
    if (nowMobile !== wasMobile) {
      wasMobile = nowMobile;
      closeAll();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-hf-science"] && !Shopify.designMode) return;
  try {
    
/* hr-nt-hf-science */
(function () {
  if (window.__hrNtSciInit) return;
  window.__hrNtSciInit = true;

  function init() {
    var SCIENCE = [
      { label: "01 · Ultra-Soft Woven Fibers", title: "Glides Without Damage", body: "Engineered to glide, not snap. The woven structure moves through tight contacts smoothly — no cutting, no tearing, no post-floss bleeding." },
      { label: "02 · Lifts Plaque Instantly", title: "Cleans Below the Surface", body: "Multi-strand woven fibers expand between teeth, lifting plaque and debris from areas smooth floss slides right past." },
      { label: "03 · Safe For Sensitive Gums", title: "Gentle Enough for Daily Use", body: "Designed for gums that bleed, recede, or react to standard floss. The soft woven texture cleans without cutting or irritating delicate tissue." },
    ];

    var SCIENCE_REFERENCES = [
      {
        title: "01 — Inflammation",
        subtitle: "How Red & Infrared Light Supports Inflammatory Balance",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Photobiomodulation (PBM) has been shown to influence key inflammatory signaling pathways in oral tissues. Red and near-infrared wavelengths interact with cells to help regulate pro-inflammatory cytokines and oxidative stress markers — both of which play a role in gum tissue breakdown.<br><br>In periodontal research, adjunctive light therapy has been associated with reduced bleeding, improved clinical attachment levels, and healthier tissue response when combined with standard care.<br><br><strong>Clinical References</strong><br><br><strong>Lee et al., 2017 – Lasers in Medical Science</strong><br>Low-level laser therapy demonstrated anti-inflammatory effects in periodontal ligament cells and reduced inflammatory mediator expression.<br><br><strong>Qadri et al., 2005 – Journal of Clinical Periodontology</strong><br>Adjunct low-level laser therapy reduced gingival inflammation and bleeding.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review describing PBM's ability to downregulate NF-κB and inflammatory cytokines.",
        figure: null
      },
      {
        title: "02 — Collagen Health",
        subtitle: "Supporting Structural Integrity of Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Collagen is the primary structural protein that anchors teeth within gum tissue. Red and near-infrared light therapy has been shown to stimulate fibroblast activity — the cells responsible for collagen production and extracellular matrix maintenance.<br><br>Laboratory and clinical studies report increased collagen synthesis and improved soft tissue repair responses following photobiomodulation.<br><br><strong>Clinical References</strong><br><br><strong>Kreisler et al., 2003 – Journal of Clinical Periodontology</strong><br>Increased gingival fibroblast proliferation after laser exposure.<br><br><strong>Pourzarandian et al., 2005 – Journal of Periodontal Research</strong><br>Enhanced collagen synthesis in gingival fibroblasts following PBM.<br><br><strong>Pinheiro &amp; Gerbi, 2006 – Photomedicine and Laser Surgery</strong><br>Review of PBM's role in connective tissue regeneration.",
        figure: null
      },
      {
        title: "03 — Blood Flow",
        subtitle: "Enhancing Microcirculation in Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared light therapy has been shown to increase local microcirculation and promote nitric oxide release, which plays a role in vascular dilation.<br><br>Improved blood flow supports oxygen delivery and nutrient transport — both essential for tissue maintenance and recovery. In periodontal contexts, PBM has been associated with improved wound healing responses and angiogenesis.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Mechanisms linking PBM to nitric oxide release and circulation effects.<br><br><strong>Romanenko et al., 2025 – Lasers in Medical Science</strong><br>Laser Doppler measurements showed increased gingival microcirculation following photobiomodulation.",
        figure: null
      },
      {
        title: "04 — Cellular Energy",
        subtitle: "Supporting Mitochondrial Function for Tissue Repair",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared photons are absorbed by mitochondrial cytochrome c oxidase, supporting cellular ATP production. Improved cellular energy underpins virtually every reparative process, including gum tissue maintenance.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Cytochrome c oxidase as the primary photoacceptor in cells.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review of PBM mechanisms via mitochondrial signaling.",
        figure: null
      }
    ];

    var scienceTabButtons = Array.prototype.slice.call(document.querySelectorAll(".hf-science-tab-item"));
    var scienceLabel = document.getElementById("hf-science-label");
    var scienceTitle = document.getElementById("hf-science-title");
    var scienceBody = document.getElementById("hf-science-body");
    var activeScienceIndex = 0;

    // Mobile: the single panel moves directly under the active tab (accordion).
    // Desktop (>=768): it returns to its grid position (right column).
    var sciencePanel = document.querySelector(".hf-science-panel");
    var sciencePanelHome = sciencePanel ? sciencePanel.parentNode : null;
    var scienceMobileMql = window.matchMedia("(max-width: 767.98px)");

    function placeSciencePanel(index) {
      if (!sciencePanel || !sciencePanelHome) return;
      if (scienceMobileMql.matches) {
        var btn = scienceTabButtons[index];
        if (btn && btn.nextElementSibling !== sciencePanel) {
          btn.insertAdjacentElement("afterend", sciencePanel);
        }
      } else if (sciencePanel.parentNode !== sciencePanelHome) {
        sciencePanelHome.appendChild(sciencePanel); // restore: last child of .hf-science-grid
      }
    }

    function setScienceState(index) {
      var safe = Math.max(0, Math.min(SCIENCE.length - 1, index));
      var item = SCIENCE[safe] || SCIENCE[0];
      activeScienceIndex = safe;
      if (scienceLabel) scienceLabel.textContent = item.label;
      if (scienceTitle) scienceTitle.textContent = item.title;
      if (scienceBody) scienceBody.textContent = item.body;
      scienceTabButtons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === safe);
      });
      placeSciencePanel(safe);
    }

    if (scienceTabButtons.length) {
      scienceTabButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var idx = Number(button.getAttribute("data-hf-science-tab")) || 0;
          setScienceState(idx);
        });
      });
      setScienceState(0);
      var onScienceMqlChange = function () { placeSciencePanel(activeScienceIndex); };
      if (scienceMobileMql.addEventListener) {
        scienceMobileMql.addEventListener("change", onScienceMqlChange);
      } else if (scienceMobileMql.addListener) {
        scienceMobileMql.addListener(onScienceMqlChange);
      }
    }

    var dialog = document.getElementById("hf-science-reference-dialog");
    var panel = dialog ? dialog.querySelector(".hf-science-reference-dialog__panel") : null;
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-hf-science-reference-open]"));
    var closers = dialog ? Array.prototype.slice.call(dialog.querySelectorAll("[data-hf-science-reference-close]")) : [];
    var refTitle = document.getElementById("hf-science-reference-title");
    var refSubtitle = document.getElementById("hf-science-reference-subtitle");
    var refSectionTitle = document.getElementById("hf-science-reference-section-title");
    var refSubsectionTitle = document.getElementById("hf-science-reference-subsection-title");
    var refBody = document.getElementById("hf-science-reference-body");
    var refFigure = document.getElementById("hf-science-reference-figure");
    var refFigureImg = document.getElementById("hf-science-reference-figure-image");
    var refFigureCap = document.getElementById("hf-science-reference-figure-caption");
    var lastTrigger = null;

    function updateRef(index) {
      var safe = Math.max(0, Math.min(SCIENCE_REFERENCES.length - 1, index));
      var r = SCIENCE_REFERENCES[safe] || SCIENCE_REFERENCES[0];
      if (refTitle) refTitle.textContent = r.title;
      if (refSubtitle) refSubtitle.textContent = r.subtitle;
      if (refSectionTitle) refSectionTitle.textContent = r.sectionTitle;
      if (refSubsectionTitle) refSubsectionTitle.textContent = r.subsectionTitle;
      if (refBody) refBody.innerHTML = r.bodyHtml;
      if (!refFigure || !refFigureImg || !refFigureCap) return;
      if (r.figure && r.figure.src) {
        refFigure.hidden = false;
        refFigureImg.setAttribute("src", r.figure.src);
        refFigureImg.setAttribute("alt", r.figure.alt || "");
        refFigureCap.innerHTML = r.figure.captionHtml || "";
        return;
      }
      refFigure.hidden = true;
      refFigureImg.removeAttribute("src");
      refFigureImg.setAttribute("alt", "");
      refFigureCap.textContent = "";
    }

    function setDialog(open) {
      if (!dialog) return;
      document.body.classList.toggle("hf-science-reference-dialog-open", open);
      dialog.classList.toggle("is-open", open);
      dialog.setAttribute("aria-hidden", String(!open));
      if (open) {
        updateRef(activeScienceIndex);
        window.setTimeout(function () { if (panel) panel.focus(); }, 0);
        return;
      }
      if (lastTrigger) lastTrigger.focus();
    }

    if (dialog && openers.length) {
      openers.forEach(function (t) {
        t.addEventListener("click", function () {
          lastTrigger = t;
          setDialog(true);
        });
      });
      closers.forEach(function (c) {
        c.addEventListener("click", function () { setDialog(false); });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-learn-experts"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initExperts(root) {
    if (root.dataset.expertsReady === '1') return;
    root.dataset.expertsReady = '1';

    var viewport = root.querySelector('[data-experts-viewport]');
    var track = viewport && viewport.querySelector('.experts__track');
    var fill = root.querySelector('[data-experts-fill]');
    var prev = root.querySelector('[data-experts-prev]');
    var next = root.querySelector('[data-experts-next]');
    if (!viewport || !track) return;

    function step() {
      var card = track.querySelector('.experts__card');
      if (!card) return viewport.clientWidth;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      var ratio = max > 0 ? viewport.scrollLeft / max : 0;
      var visible = viewport.clientWidth / viewport.scrollWidth;
      if (fill) fill.style.width = Math.max(15, Math.min(100, (ratio * (1 - visible) + visible) * 100)) + '%';
      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: 'smooth' }); });
    viewport.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Inline video playback — click play swaps poster for <video>; one at a time.
    var cards = Array.prototype.slice.call(track.querySelectorAll('.experts__card'));
    function stopCard(card) {
      var v = card.querySelector('.experts__video');
      if (v) { v.pause(); if (!v.ended && v.currentTime > 0) v.currentTime = 0; }
      card.classList.remove('is-playing');
    }
    cards.forEach(function (card) {
      var media = card.querySelector('.experts__media');
      var play = card.querySelector('.experts__play');
      var video = card.querySelector('.experts__video');
      var src = media ? media.getAttribute('data-video-src') : '';
      if (!media || !play || !video || !src) return;
      play.addEventListener('click', function () {
        if (card.classList.contains('is-playing')) { stopCard(card); return; }
        cards.forEach(function (other) { if (other !== card) stopCard(other); });
        if (!video.getAttribute('src')) video.setAttribute('src', src);
        card.classList.add('is-playing');
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      video.addEventListener('ended', function () { stopCard(card); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-experts]').forEach(initExperts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  // Re-init when the Theme Editor re-renders this section.
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-mouth-body"] && !Shopify.designMode) return;
  try {
    
(function () {
                const root = document.querySelector(".mouth-body");
                if (!root) return;
                const tabs = root.querySelectorAll(".mouth-body__tab");
                const images = root.querySelectorAll(".mouth-body__image");
                const details = root.querySelectorAll(
                    ".mouth-body__detail-item",
                );

                function activate(step) {
                    tabs.forEach((t) => {
                        const on = t.dataset.step === step;
                        t.classList.toggle("is-active", on);
                        t.setAttribute("aria-selected", on ? "true" : "false");
                    });
                    images.forEach((img) =>
                        img.classList.toggle(
                            "is-active",
                            img.dataset.step === step,
                        ),
                    );
                    details.forEach((d) =>
                        d.classList.toggle(
                            "is-active",
                            d.dataset.step === step,
                        ),
                    );
                }

                tabs.forEach((tab) => {
                    tab.addEventListener("click", () =>
                        activate(tab.dataset.step),
                    );
                });
            })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-nfc-products"] && !Shopify.designMode) return;
  try {
    
/* Products carousel — duplicated from the upsell slider in rlt-slider.js so this page
   behaves like the others: the fill shows how much of the track has been revealed
   (grows to 100% at the end), arrows page by one card pitch, controls hide with no
   overflow. The fill is a PROGRESS bar, not a scrollbar thumb — set width only. */
(function () {
  function init(sec) {
    var track = sec.querySelector('[data-track]');
    if (!track) return;
    var fill = sec.querySelector('[data-fill]');
    var controls = sec.querySelector('.nfc-products__controls');
    var prev = sec.querySelector('[data-dir="-1"]');
    var next = sec.querySelector('[data-dir="1"]');

    /* Pitch measured off two real cards, so it follows the gap/width at any breakpoint. */
    function step() {
      var cards = track.querySelectorAll('.nfc-products__card');
      if (!cards.length) return track.clientWidth * 0.8;
      if (cards.length < 2) return cards[0].offsetWidth;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var canScroll = max > 4;
      if (controls) controls.classList.toggle('is-hidden', !canScroll);
      if (!canScroll) {
        if (fill) fill.style.width = '100%';
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 1;
      if (next) next.disabled = x >= max - 1;
      if (fill) fill.style.width = Math.min(100, ((x + track.clientWidth) / track.scrollWidth) * 100) + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    update();
  }
  document.querySelectorAll('.nfc-products').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-nt-science"] && !Shopify.designMode) return;
  try {
    
/* hr-nt-science */
(function () {
  if (window.__hrNtSciInit) return;
  window.__hrNtSciInit = true;

  function init() {
    var SCIENCE = [
      { label: "01 · 12,000+ Nano Bristles", title: "Cleans What Others Miss", body: "Thinner than a human hair. Dense enough to reach spaces standard bristles skip entirely." },
      { label: "02 · Wave-Pattern Bristle Design", title: "Follows Your Gumline", body: "Contoured to follow the natural shape of the gumline — guiding bristle tips directly into pockets with every stroke." },
      { label: "03 · Deep Gum Pocket Access", title: "Reaches Where Disease Starts", body: "Nano-fiber density reaches the sulcus — the narrow gap between tooth and gum where buildup and inflammation actually start." },
      { label: "04 · Gum-Tissue Safe", title: "Protects Fragile Tissue", body: "Thousands of contact points distribute pressure evenly — no concentrated force, no micro-tears, no recession risk." },
    ];

    var SCIENCE_REFERENCES = [
      {
        title: "01 — Inflammation",
        subtitle: "How Red & Infrared Light Supports Inflammatory Balance",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Photobiomodulation (PBM) has been shown to influence key inflammatory signaling pathways in oral tissues. Red and near-infrared wavelengths interact with cells to help regulate pro-inflammatory cytokines and oxidative stress markers — both of which play a role in gum tissue breakdown.<br><br>In periodontal research, adjunctive light therapy has been associated with reduced bleeding, improved clinical attachment levels, and healthier tissue response when combined with standard care.<br><br><strong>Clinical References</strong><br><br><strong>Lee et al., 2017 – Lasers in Medical Science</strong><br>Low-level laser therapy demonstrated anti-inflammatory effects in periodontal ligament cells and reduced inflammatory mediator expression.<br><br><strong>Qadri et al., 2005 – Journal of Clinical Periodontology</strong><br>Adjunct low-level laser therapy reduced gingival inflammation and bleeding.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review describing PBM's ability to downregulate NF-κB and inflammatory cytokines.",
        figure: null
      },
      {
        title: "02 — Collagen Health",
        subtitle: "Supporting Structural Integrity of Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Collagen is the primary structural protein that anchors teeth within gum tissue. Red and near-infrared light therapy has been shown to stimulate fibroblast activity — the cells responsible for collagen production and extracellular matrix maintenance.<br><br>Laboratory and clinical studies report increased collagen synthesis and improved soft tissue repair responses following photobiomodulation.<br><br><strong>Clinical References</strong><br><br><strong>Kreisler et al., 2003 – Journal of Clinical Periodontology</strong><br>Increased gingival fibroblast proliferation after laser exposure.<br><br><strong>Pourzarandian et al., 2005 – Journal of Periodontal Research</strong><br>Enhanced collagen synthesis in gingival fibroblasts following PBM.<br><br><strong>Pinheiro &amp; Gerbi, 2006 – Photomedicine and Laser Surgery</strong><br>Review of PBM's role in connective tissue regeneration.",
        figure: null
      },
      {
        title: "03 — Blood Flow",
        subtitle: "Enhancing Microcirculation in Gum Tissue",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared light therapy has been shown to increase local microcirculation and promote nitric oxide release, which plays a role in vascular dilation.<br><br>Improved blood flow supports oxygen delivery and nutrient transport — both essential for tissue maintenance and recovery. In periodontal contexts, PBM has been associated with improved wound healing responses and angiogenesis.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Mechanisms linking PBM to nitric oxide release and circulation effects.<br><br><strong>Romanenko et al., 2025 – Lasers in Medical Science</strong><br>Laser Doppler measurements showed increased gingival microcirculation following photobiomodulation.",
        figure: null
      },
      {
        title: "04 — Cellular Energy",
        subtitle: "Supporting Mitochondrial Function for Tissue Repair",
        sectionTitle: "What the Research Shows",
        subsectionTitle: "",
        bodyHtml: "Red and near-infrared photons are absorbed by mitochondrial cytochrome c oxidase, supporting cellular ATP production. Improved cellular energy underpins virtually every reparative process, including gum tissue maintenance.<br><br><strong>Clinical References</strong><br><br><strong>Karu, 1999 – Journal of Photochemistry and Photobiology B</strong><br>Cytochrome c oxidase as the primary photoacceptor in cells.<br><br><strong>Hamblin, 2017 – Photochemistry and Photobiology</strong><br>Review of PBM mechanisms via mitochondrial signaling.",
        figure: null
      }
    ];

    var scienceTabButtons = Array.prototype.slice.call(document.querySelectorAll(".nt-science-tab-item"));
    var scienceLabel = document.getElementById("nt-science-label");
    var scienceTitle = document.getElementById("nt-science-title");
    var scienceBody = document.getElementById("nt-science-body");
    var activeScienceIndex = 0;

    // Mobile: the single panel moves directly under the active tab (accordion).
    // Desktop (>=768): it returns to its grid position (right column).
    var sciencePanel = document.querySelector(".nt-science-panel");
    var sciencePanelHome = sciencePanel ? sciencePanel.parentNode : null;
    var scienceMobileMql = window.matchMedia("(max-width: 767.98px)");

    function placeSciencePanel(index) {
      if (!sciencePanel || !sciencePanelHome) return;
      if (scienceMobileMql.matches) {
        var btn = scienceTabButtons[index];
        if (btn && btn.nextElementSibling !== sciencePanel) {
          btn.insertAdjacentElement("afterend", sciencePanel);
        }
      } else if (sciencePanel.parentNode !== sciencePanelHome) {
        sciencePanelHome.appendChild(sciencePanel); // restore: last child of .nt-science-grid
      }
    }

    function setScienceState(index) {
      var safe = Math.max(0, Math.min(SCIENCE.length - 1, index));
      var item = SCIENCE[safe] || SCIENCE[0];
      activeScienceIndex = safe;
      if (scienceLabel) scienceLabel.textContent = item.label;
      if (scienceTitle) scienceTitle.textContent = item.title;
      if (scienceBody) scienceBody.textContent = item.body;
      scienceTabButtons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === safe);
      });
      placeSciencePanel(safe);
    }

    if (scienceTabButtons.length) {
      scienceTabButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var idx = Number(button.getAttribute("data-nt-science-tab")) || 0;
          setScienceState(idx);
        });
      });
      setScienceState(0);
      // Re-place the panel when crossing the mobile/desktop breakpoint.
      var onScienceMqlChange = function () { placeSciencePanel(activeScienceIndex); };
      if (scienceMobileMql.addEventListener) {
        scienceMobileMql.addEventListener("change", onScienceMqlChange);
      } else if (scienceMobileMql.addListener) {
        scienceMobileMql.addListener(onScienceMqlChange);
      }
    }

    var dialog = document.getElementById("nt-science-reference-dialog");
    var panel = dialog ? dialog.querySelector(".nt-science-reference-dialog__panel") : null;
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-nt-science-reference-open]"));
    var closers = dialog ? Array.prototype.slice.call(dialog.querySelectorAll("[data-nt-science-reference-close]")) : [];
    var refTitle = document.getElementById("nt-science-reference-title");
    var refSubtitle = document.getElementById("nt-science-reference-subtitle");
    var refSectionTitle = document.getElementById("nt-science-reference-section-title");
    var refSubsectionTitle = document.getElementById("nt-science-reference-subsection-title");
    var refBody = document.getElementById("nt-science-reference-body");
    var refFigure = document.getElementById("nt-science-reference-figure");
    var refFigureImg = document.getElementById("nt-science-reference-figure-image");
    var refFigureCap = document.getElementById("nt-science-reference-figure-caption");
    var lastTrigger = null;

    function updateRef(index) {
      var safe = Math.max(0, Math.min(SCIENCE_REFERENCES.length - 1, index));
      var r = SCIENCE_REFERENCES[safe] || SCIENCE_REFERENCES[0];
      if (refTitle) refTitle.textContent = r.title;
      if (refSubtitle) refSubtitle.textContent = r.subtitle;
      if (refSectionTitle) refSectionTitle.textContent = r.sectionTitle;
      if (refSubsectionTitle) refSubsectionTitle.textContent = r.subsectionTitle;
      if (refBody) refBody.innerHTML = r.bodyHtml;
      if (!refFigure || !refFigureImg || !refFigureCap) return;
      if (r.figure && r.figure.src) {
        refFigure.hidden = false;
        refFigureImg.setAttribute("src", r.figure.src);
        refFigureImg.setAttribute("alt", r.figure.alt || "");
        refFigureCap.innerHTML = r.figure.captionHtml || "";
        return;
      }
      refFigure.hidden = true;
      refFigureImg.removeAttribute("src");
      refFigureImg.setAttribute("alt", "");
      refFigureCap.textContent = "";
    }

    function setDialog(open) {
      if (!dialog) return;
      document.body.classList.toggle("nt-science-reference-dialog-open", open);
      dialog.classList.toggle("is-open", open);
      dialog.setAttribute("aria-hidden", String(!open));
      if (open) {
        updateRef(activeScienceIndex);
        window.setTimeout(function () { if (panel) panel.focus(); }, 0);
        return;
      }
      if (lastTrigger) lastTrigger.focus();
    }

    if (dialog && openers.length) {
      openers.forEach(function (t) {
        t.addEventListener("click", function () {
          lastTrigger = t;
          setDialog(true);
        });
      });
      closers.forEach(function (c) {
        c.addEventListener("click", function () { setDialog(false); });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-product-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__hrHowInit) return;
  window.__hrHowInit = true;

  function init() {
    /* ---- step accordion ---- */
    var steps = Array.prototype.slice.call(document.querySelectorAll(".step"));

    function syncStepHeights() {
      steps.forEach(function (step) {
        var bodyEl = step.querySelector(".step-body");
        if (!bodyEl) return;
        var styles = window.getComputedStyle(bodyEl);
        var targetPaddingTop = parseFloat(styles.getPropertyValue("--step-body-top")) || 0;
        var currentPaddingTop = parseFloat(styles.paddingTop) || 0;
        var contentHeight = Math.max(0, bodyEl.scrollHeight - currentPaddingTop + targetPaddingTop);
        bodyEl.style.setProperty("--accordion-content-height", Math.ceil(contentHeight) + "px");
      });
    }

    function openStep(stepToOpen) {
      steps.forEach(function (step) {
        var buttonEl = step.querySelector(".step-toggle");
        var isTarget = step === stepToOpen;
        step.classList.remove("is-closing");
        step.classList.toggle("is-open", isTarget);
        if (buttonEl) buttonEl.setAttribute("aria-expanded", String(isTarget));
      });
    }

    if (steps.length) {
      var initialOpen = steps.find(function (s) { return s.classList.contains("is-open"); }) || steps[0];
      openStep(initialOpen);
      syncStepHeights();

      steps.forEach(function (step) {
        var toggle = step.querySelector(".step-toggle");
        if (!toggle) return;
        toggle.addEventListener("click", function () {
          if (step.classList.contains("is-open")) return;
          syncStepHeights();
          openStep(step);
        });
      });

      var resizeRaf = 0;
      function onResize() {
        if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
        resizeRaf = window.requestAnimationFrame(function () {
          syncStepHeights();
          resizeRaf = 0;
        });
      }
      window.addEventListener("resize", onResize);
      window.addEventListener("load", onResize);
    }

    /* ---- ingredient dialog ---- */
    var dialog = document.getElementById("ingredients-dialog");
    var panel = dialog ? dialog.querySelector(".hiw-drawer") : null;
    var openers = Array.prototype.slice.call(document.querySelectorAll("[data-ingredient-dialog-open]"));
    var closers = dialog ? Array.prototype.slice.call(dialog.querySelectorAll("[data-ingredient-dialog-close]")) : [];
    var lastTrigger = null;

    function setDialog(open) {
      if (!dialog) return;
      document.body.classList.toggle("ingredient-dialog-open", open);
      dialog.classList.toggle("is-open", open);
      dialog.setAttribute("aria-hidden", String(!open));
      if (open) {
        window.setTimeout(function () { if (panel) panel.focus(); }, 0);
        return;
      }
      if (lastTrigger) lastTrigger.focus();
    }

    if (dialog && openers.length) {
      openers.forEach(function (t) {
        t.addEventListener("click", function (event) {
          event.preventDefault();
          lastTrigger = t;
          setDialog(true);
        });
      });
      closers.forEach(function (c) {
        c.addEventListener("click", function () { setDialog(false); });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-product-science"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__hrSciInit) return;
  window.__hrSciInit = true;

  function init() {
    var SCIENCE = [
      { label: "01 · Inflammation", title: "Helps calm chronic inflammation", body: "Clinical research shows light therapy helps reduce inflammatory signaling in tissue — supporting a healthier environment." },
      { label: "02 · Collagen Health", title: "Supports collagen health and tissue strength", body: "Red and near-infrared wavelengths are associated with collagen-supportive activity, helping gum tissue stay resilient over time." },
      { label: "03 · Blood Flow", title: "Encourages healthier microcirculation", body: "Photobiomodulation can support local blood flow to deliver oxygen and nutrients needed for gum maintenance and recovery." },
      { label: "04 · Cellular Energy", title: "Supports cellular energy production", body: "Light energy helps support mitochondrial function, improving the cell-level energy needed for repair and long-term gum stability." },
    ];

    var scienceTabButtons = Array.prototype.slice.call(document.querySelectorAll(".rlt-science-tab-item"));
    var scienceLabel = document.getElementById("rlt-science-label");
    var scienceTitle = document.getElementById("rlt-science-title");
    var scienceBody = document.getElementById("rlt-science-body");
    var activeScienceIndex = 0;

    // Mobile: the single panel moves directly under the active tab (accordion).
    // Desktop (>=768): it returns to its grid position (right column).
    var sciencePanel = document.querySelector(".rlt-science-panel");
    var sciencePanelHome = sciencePanel ? sciencePanel.parentNode : null;
    var scienceMobileMql = window.matchMedia("(max-width: 767.98px)");

    function placeSciencePanel(index) {
      if (!sciencePanel || !sciencePanelHome) return;
      if (scienceMobileMql.matches) {
        var btn = scienceTabButtons[index];
        if (btn && btn.nextElementSibling !== sciencePanel) {
          btn.insertAdjacentElement("afterend", sciencePanel);
        }
      } else if (sciencePanel.parentNode !== sciencePanelHome) {
        sciencePanelHome.appendChild(sciencePanel); // restore: last child of .rlt-science-grid
      }
    }

    function setScienceState(index) {
      var safe = Math.max(0, Math.min(SCIENCE.length - 1, index));
      var item = SCIENCE[safe] || SCIENCE[0];
      activeScienceIndex = safe;
      if (scienceLabel) scienceLabel.textContent = item.label;
      if (scienceTitle) scienceTitle.textContent = item.title;
      if (scienceBody) scienceBody.textContent = item.body;
      scienceTabButtons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === safe);
      });
      placeSciencePanel(safe);
    }

    if (scienceTabButtons.length) {
      scienceTabButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var idx = Number(button.getAttribute("data-rlt-science-tab")) || 0;
          setScienceState(idx);
        });
      });
      setScienceState(0);
      // Re-place the panel when crossing the mobile/desktop breakpoint.
      var onScienceMqlChange = function () { placeSciencePanel(activeScienceIndex); };
      if (scienceMobileMql.addEventListener) {
        scienceMobileMql.addEventListener("change", onScienceMqlChange);
      } else if (scienceMobileMql.addListener) {
        scienceMobileMql.addListener(onScienceMqlChange);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-track-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Tracking number form: append the number to the configured URL and open in a new tab.
  // Default URL is 17track.net — accepts ?nums=<n>. Custom URLs receive ?nums=<n> appended.
  document.querySelectorAll('[data-tracking-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[name="nums"]');
      var num = input && input.value.trim();
      if (!num) return;
      var base = form.getAttribute('action') || '';
      if (!base) return;
      e.preventDefault();
      var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'nums=' + encodeURIComponent(num);
      window.open(url, '_blank', 'noopener');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-track-status"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.copy-btn[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy');
      if (!text || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
      });
    });
  });

  document.querySelectorAll('[data-history-toggle]').forEach(function (toggle) {
    var card = toggle.closest('[data-history]');
    if (!card) return;
    var rows = card.querySelectorAll('[data-history-row]');
    var more = toggle.querySelector('[data-history-label-more]');
    var less = toggle.querySelector('[data-history-label-less]');

    rows.forEach(function (row) {
      if (row.classList.contains('history-row--hidden')) {
        row.dataset.collapsedHide = '1';
      }
    });

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var next = !expanded;
      toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
      rows.forEach(function (row) {
        if (next) {
          row.classList.remove('history-row--hidden');
        } else if (row.dataset.collapsedHide === '1') {
          row.classList.add('history-row--hidden');
        }
      });
      if (more) more.hidden = next;
      if (less) less.hidden = !next;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hr-ts-science"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__hrTsSciInit) return;
  window.__hrTsSciInit = true;

  function init() {
    var SCIENCE = [
      { label: "01 · Precision-Curved Edge", title: "Precision-Curved Edge", body: "Contours naturally to the tongue’s surface for even pressure and a thorough, comfortable clean in a single pass." },
      { label: "02 · Medical-Grade Stainless Steel", title: "Medical-Grade Stainless Steel", body: "Built from surgical-grade stainless steel that resists corrosion, doesn’t harbor bacteria, and maintains its edge over years of daily use." },
      { label: "03 · Microbiome-Conscious Design", title: "Microbiome-Conscious Design", body: "Removes bacterial buildup mechanically — without chemicals, abrasives, or antimicrobial agents that could disrupt the tongue’s natural microbial balance." }
    ];

    var tabButtons = Array.prototype.slice.call(document.querySelectorAll("[data-ts-science-tab]"));
    var labelEl = document.getElementById("ts-science-label");
    var titleEl = document.getElementById("ts-science-title");
    var bodyEl = document.getElementById("ts-science-body");

    // Mobile: the single panel moves directly under the active tab (accordion).
    // Desktop (>=768): it returns to its grid position (right column).
    var sciencePanel = document.querySelector(".ts-science-panel");
    var sciencePanelHome = sciencePanel ? sciencePanel.parentNode : null;
    var scienceMobileMql = window.matchMedia("(max-width: 767.98px)");
    var activeIndex = 0;

    function placeSciencePanel(index) {
      if (!sciencePanel || !sciencePanelHome) return;
      if (scienceMobileMql.matches) {
        var btn = tabButtons[index];
        if (btn && btn.nextElementSibling !== sciencePanel) {
          btn.insertAdjacentElement("afterend", sciencePanel);
        }
      } else if (sciencePanel.parentNode !== sciencePanelHome) {
        sciencePanelHome.appendChild(sciencePanel); // restore: last child of .ts-science-grid
      }
    }

    function setActive(index) {
      var safe = Math.max(0, Math.min(SCIENCE.length - 1, index));
      var item = SCIENCE[safe];
      activeIndex = safe;
      if (labelEl) labelEl.textContent = item.label;
      if (titleEl) titleEl.textContent = item.title;
      if (bodyEl) bodyEl.textContent = item.body;
      tabButtons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === safe);
      });
      placeSciencePanel(safe);
    }

    if (tabButtons.length) {
      tabButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var idx = Number(button.getAttribute("data-ts-science-tab")) || 0;
          setActive(idx);
        });
      });
      setActive(0);
      // Re-place the panel when crossing the mobile/desktop breakpoint.
      var onScienceMqlChange = function () { placeSciencePanel(activeIndex); };
      if (scienceMobileMql.addEventListener) {
        scienceMobileMql.addEventListener("change", onScienceMqlChange);
      } else if (scienceMobileMql.addListener) {
        scienceMobileMql.addListener(onScienceMqlChange);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
